<div class="dialog-container-main right-side-popup ">
  <div class="dialog-header">
    <h2 mat-dialog-title>Withdraw Application</h2>
    <button mat-button mat-dialog-close><span class="material-icons">close</span></button>
  </div>

  <form [formGroup]="applicationForm" >
    <div class="mat-typography right-side-content   ">
      <div class="row">
        <!-- <div class="col m12 s12">
        <h5 class="text-center">Withdraw Application</h5>
        </div> -->
        <div class="col m12 s12">
          <div class="field-group selectfield">
            <mat-label class="labelsuper-normal" >Why do you want to withdraw the application?</mat-label>
            <mat-form-field appearance="fill" class="selectfield">
                <mat-select  formControlName="opportunitystatuscode">
                    <mat-option *ngFor = "let element of statusCodes" [value]="element.id">{{element.value}}</mat-option>
                    </mat-select>
            </mat-form-field>

        </div>
        
          <!-- <mat-form-field appearance="fill" class="selectfield">
            <mat-label>Why do you want to withdraw the application?</mat-label>
            <mat-select formControlName="opportunitystatuscode" >
              <mat-option *ngFor = "let element of statusCodes" [value]="element.id">{{element.value}}</mat-option>
            </mat-select>

          </mat-form-field> -->

          <!-- <mat-form-field appearance="outline" class="custom-form-field">
            <mat-label>Actually Revenue</mat-label>
            <input matInput formControlName="actualrevenue" currencyInput  type="text" autofilled="off"
              />
            </mat-form-field> -->

          <!-- <mat-form-field appearance="outline" class="custom-form-field">
            <mat-label>Close Date</mat-label>
            <input
                  matInput
                  [matDatepicker]="picker1"
                  [max]="todayDate"
                  formControlName="actualend"
                  disabled
                  placeholder="DD/MM/YYYY"

                />

                <mat-datepicker-toggle class="calender-icon"
                  matSuffix
                  [for]="picker1"

                ></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field> -->

          


        </div>

        <div class="col m12 s12 margin-top2">
          <div class="field-group selectfield">
            <mat-label class="labelsuper-normal">Comment</mat-label>
            <mat-form-field appearance="outline" class="custom-form-field textarea100">
              <textarea matInput rows="5"  formControlName="description" placeholder="Type something..."></textarea>
            </mat-form-field>

          </div>

        </div>
      </div>

        



    </div>

    <!-- <div class="button-footer">
      <button mat-button matStepperPrevious >Cacnel</button>
      <button mat-button matStepperNext (click)="onSubmit()">Submit</button>
    </div> -->
    <!-- <mat-divider class="divider"></mat-divider> -->

      <mat-dialog-actions class="btn-col-footer ">
        <button mat-button color="primary" mat-dialog-close >Cancel</button>
        <button
        mat-flat-button
          cdkFocusInitial
          class="next-button"
  (click)="onSubmit()"
        >
        Submit
        </button>
      </mat-dialog-actions>

  </form>

</div>
